export default __webpack_public_path__ + "static/media/Code Translations.d320b5fb.xlsx";